import * as Yup from 'yup';
import { BusinessOutlined, LightbulbOutlined } from '@mui/icons-material';
export const TestCaseTypeOptions = [
  'Smoke',
  'Regression',
  'Functional',
  'UAT',
  'Production check',
];

export const TestCasePriorityOptions = ['Low', 'Medium', 'High', 'Critical'];

export const TestCaseStatusOptions = ['Low', 'Medium', 'High', 'Critical'];

export const CsvImportDelimiterOptions = [
  { key: ',', label: 'Comma (,)' },
  { key: ';', label: 'Semicolon (;)' },
  { key: '|', label: 'Pipe (|)' },
  { key: '\t', label: 'Tab (\\t)' }
];

export const gainssTestCaseFields = [
  { key: 'summary', label: 'Description (max 255 characters)' },
  { key: 'objective', label: 'Objective (max 500 characters)' },
  { key: 'preCondition', label: 'Pre-condition (max 500 characters)' },
  {key: 'technologyLayer', label: 'Technology layer'},
  { key: 'module', label: 'Module' },
  { key: 'owner', label: 'Owner' },
  { key: 'labels', label: 'Labels (Comma-Separated)' },
  { key: 'country', label: 'Country (Comma-Separated)' },
  {
    key: 'isAutomationNeeded',
    label: 'Candidate for Automation',
  },
  {
    key: 'automationStatus',
    label: 'Automation Status',
  },
  {
    key: 'isAutomated',
    label: 'Is Automated',
  },
  {
    key: 'automationMethod',
    label: 'Automation Method (max 100 characters)',
  },
  {
    key: 'automatedBy',
    label: 'Automated By',
  },
  {key: 'automationCountry', label: 'Automated For Country (Comma-Separated)'},
  { key: 'reasonForNotAutomated', label: 'Reason For Not Automating' },       
  { key: 'notAutomatedCategory', label: 'Not Automated Category' },      
  { key: 'notAutomatedSubCategory', label: 'Not Automated Sub Category' }, 
  { key: 'step', label: 'Step Description (max 2000 characters)' },
  { key: 'testData', label: 'Test Step Data (max 2000 characters)' },
  {
    key: 'expectedResult',
    label: 'Test Step Expected Result (max 2000 characters)',
  },
  { key: 'uri', label: 'Test Step URI (max 250 characters)' },
  {
    key: 'jiraIssues',
    label: 'Linked Issues (Comma-Separated)',
  }
];

export const purposeOptions = [
  'Sanity',
  'Regression',
  'Sprint Validation',
  'UAT',
  'Production',
];

export const testCyleTypeOptions = [
  'Manual',
  'Automation',
]

export const techLayers = [
  'None',
  'Database',
  'Contract',
  'API/Integration',
  'Web Front-end',
  'Mobile Front-end',
];

export const automationStatuses = ['Todo', 'In Progress', 'Blocked', 'Done'];


export const techLayerFilters = [
  'All',
  'Database',
  'Contract',
  'API/Integration',
  'Web Front-end',
  'Mobile Front-end',
];
export const STEPS = [
  { label: 'Organization Details', sublabel: 'Company info & contact', icon: BusinessOutlined },
  { label: 'Why GAiNSS?',          sublabel: 'Your evaluation goals',   icon: LightbulbOutlined },
];

/* ─── Per-step Yup Schemas ──────────────────────────────────────────────────── */
export const STEP_SCHEMAS = [
  Yup.object({
    organization: Yup.string()
      .max(255)
      .required('Organization name is required'),
    website: Yup.string()
      .url('Enter a valid URL (e.g. https://example.com)')
      .required('Website is required'),
    linkedin: Yup.string()
      .url('Enter a valid LinkedIn URL')
      .matches(/linkedin\.com/, 'Must be a LinkedIn URL')
      .optional()
      .nullable()
      .transform((v) => v || null),
    phoneNumber: Yup.string().optional(),
  }),
  Yup.object({
    evaluationReason: Yup.string().max(1000).optional(),
  }),
];
export const INDUSTRY_OPTIONS = [
  'Banking & Financial Services',
'Healthcare & Life Sciences',
'Insurance',
'Retail & E-Commerce',
'Telecommunications',
'Manufacturing',
'Energy & Utilities',
'Government & Public Sector',
'Media & Entertainment',
'Education',
'Technology / SaaS',
'Consulting & Professional Services',
'Other',
];